import { IAppState } from "../state";

export const usuarioSelector = (appState: IAppState) => appState.usuario;